import React from 'react';
import { css } from '@emotion/core';
import styled from '@emotion/styled';

const ResumeTrackbar = styled('div')`
  position: absolute;
  right: 0;
  bottom: -3px;
  left: 0;
  ${props => `background: ${props.bkg};`}
  
  .video-teaser-hover > & {
    bottom: -5px;
    box-shadow: 0 0 1px 0 #000;
  }
  
`;

const resumeProgress = css`
  position: relative;
  height: 6px;
`

export default class ResumePlayback extends React.Component {
  barStyle() {
    return {
      width: `${this.props.progress}%`,
      background: this.props.foreground || '#05c789'
    };
  }

  render() {
    return <ResumeTrackbar className='resume-trackbar' bkg={this.props.background || '#333'}>
      <div css={resumeProgress} style={this.barStyle()} />
    </ResumeTrackbar>;
  }
}